<template>
  <v-container
    class="LKPassportListFilter"
  >
    <v-row dense>
      <v-col cols="12">
        <BTextField
          v-model="form.login"
          :label="label"
          :loading="isLoading"
          :skeleton="skeleton"
          :placeholder="placeholder"
          @input="onChangeDebounced"
          @keydown="onKeyDown"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <BTextFieldAte
          :region.sync="form.region"
          :municipality.sync="form.municipality"
          :school.sync="form.school"
          :skeleton="skeleton"
          model="User"
          style="min-width: 320px;"
          placeholder="Выберите ATE"
          @change="onChangeDebounced"
          @click:clear="onClearAte"
        />
      </v-col>
      <v-col :sm="6">
        <BAutocompleteSelect
          v-model="form.status"
          :skeleton="skeleton"
          :options="statuses"
          item-value="value"
          item-text="text"
          :return-object="false"
          label="Статус"
          class="LKPassportListFilter__Autocomplete"
          @change="onChangeDebounced"
        />
      </v-col>

      <v-col :sm="6">
        <BAutocompleteSelect
          disabled
          :value="'ОО'"
          :options="['ОО']"
          class="LKPassportListFilter__Autocomplete"
          label="Тип паспорта"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { LkPassportStatus } from '@/typings/api/Passport'
import BListFilter from '@/components/forms/BListFilter.vue'
import BAutocompleteSelect from '@/components/forms/BAutocompleteCommon/BAutocompleteSelect.vue'
import BTextFieldAte from '@/views/LKPublications/formdata/components/LKTextFieldAteFormdata.vue'


const createDefaultDataFilters = () => ({
  login: void 0,
  status: void 0,
  region: void 0,
  municipality: void 0,
  school: void 0,
})

export default {
  name: 'UsersFilter',
  components: {
    BAutocompleteSelect,
    BTextFieldAte,
  },
  extends: BListFilter,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      default: createDefaultDataFilters,
    },
  },
  data: () => ({
    statuses: [
      {
        value: null,
        text: 'Любой',
      },
      {
        value: LkPassportStatus.NOT_STARTED,
        text: 'Не приступал',
      },
      {
        value: LkPassportStatus.IN_PROGRESS,
        text: 'В работе',
      },
      {
        value: LkPassportStatus.SUBMITTED,
        text: 'Сдано',
      },
    ],
  }),
  methods: {
    onClearAte() {
      this.form = {
        ...this.form,
        region: void 0,
        municipality: void 0,
        school: void 0,
      }

      this.onChangeDebounced()
    },
    setFilters(filters) {
      this.form = {
        ...this.form,
        ...filters,
      }
      this.onChangeDebounced()
    },
  },
}
</script>

<style lang="scss">
.BAteTreeFormRecursiveCheckbox {
  padding: 0;
  margin: 0;
}

.b-ate-tree-form-recursive {
  padding-top: 0;
  padding-bottom: 0;
}

.LKPassportListFilter {
  &__Autocomplete {
    .v-input__slot {
      // height: 44px;
    }
  }
}
</style>
